// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__6Yx_d","emails":"CreateEditClinics_emails__1Mr2l","emailTagLabel":"CreateEditClinics_emailTagLabel__1OfC9"};